import { render, staticRenderFns } from "./GiftCard.vue?vue&type=template&id=3b8a4cc0&scoped=true&"
import script from "./GiftCard.vue?vue&type=script&lang=ts&"
export * from "./GiftCard.vue?vue&type=script&lang=ts&"
import style0 from "./GiftCard.vue?vue&type=style&index=0&id=3b8a4cc0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8a4cc0",
  null
  
)

export default component.exports